import { render, staticRenderFns } from "./image-photo.vue?vue&type=template&id=02549634&lang=html&"
import script from "./image-photo.vue?vue&type=script&lang=js&"
export * from "./image-photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports